import reportCardValidationPopup from '../views/report-card-validation-popup.html';
class ReportCardGenConsoleCtrl {
    constructor($scope, $state, $window, $stateParams, $mdDialog,  $mdMedia, authService,
        localStorageService, setAndSelectStudentRc, $rootScope, RC_CONSTANTS_) {
            'ngInject';
        let self = this
        let authoring = localStorageService.get('authoringData')
        let sessionData = localStorageService.get('authoringData')
        let activeAcd = localStorageService.get('academic_year')
        var subjectId = sessionData.subject_id
        var xClassId = sessionData.class_id
        var curriculumId = sessionData.curriculum_id
        var batchId = sessionData.batch_id
        var sessionId = sessionData.session_id
        let templateCardId = $stateParams.cardId
        let re_generate = $stateParams.re_generate ? $stateParams.re_generate : false
        let dataId = $stateParams.dataId ? $stateParams.dataId : false
        let fromCt = $stateParams.fromCt ? $stateParams.fromCt : false
        $scope.copyOfActivities = []
        $scope.get_students_selected = setAndSelectStudentRc.get_students_selected();

        if (subjectId && xClassId && curriculumId && sessionId && batchId && templateCardId) {
            var activityCondition = {
                "subject_id": subjectId,
                "session_id": sessionId,
                "curriculum_id": curriculumId,
                "class_id": xClassId,
                "batch_id": batchId,
                "school_id": sessionData.school_id
            }
            if(fromCt != "false"){
                let cTData = localStorageService.get('cTregen')
                activityCondition = {
                    "subject_id": cTData.subject_id,
                    "session_id": cTData.session_id,
                    "curriculum_id": cTData.curriculum_id,
                    "class_id": cTData.class_id,
                    "batch_id": cTData.batch_id,
                    "school_id": cTData.school_id
                }
            }
            let obj = {
                cardId : templateCardId,
                activityCondition : activityCondition,
                page : true,
                re_generate : re_generate,
                fromCt : fromCt,
                activeAcd : activeAcd,
                get_students_selected : $scope.get_students_selected,
                my_user_id : localStorageService.get('user_id'),
                regenarateFlag : re_generate
            }
            this.$onInit = () => {
                $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
                if (!$rootScope.isLoggedIn) {
                  $state.go("login", {}, { reload: true })
                }
                pushLog();
            }
            authService.callAPI("/v0/reportcards/teacher/genration", "POST",
                {args : obj, subject_id:authoring.subject_id}, function (response) {

                let result = response.result.data.details.response
                if (result && result.report_template && result.activities) {
                    if (result.redirectList) { //not to show console page again while clicking back button;redirects to listing page
                        $state.go('reportCardListing')
                    }
                    let templateCard = result.report_template;
                    $scope.templateCard = templateCard
                    let activities = result.activities;
                    let activityKeys = Object.keys(activities);
                    let arrayActivity = [];
                    _.each(activityKeys, function(activityType) {
                        let obj = {
                            name: activityType,
                            type: activityType.toLowerCase(),
                            list: activities[activityType]
                        }
                        arrayActivity.push(obj);
                    });
                    $scope.activities = arrayActivity;
                    // _.each(templateCard.activity_buckets, function(each) {
                    //     _.each(each.sub_skills, function(sub) {
                    //         sub.list = [];
                    //     });
                    // });
                    $scope.activities[0].showItem = true
                    $scope.selectedactivities = templateCard.activity_buckets
                    $scope.have_sub_skill = templateCard.have_skill_subskill_format
                    if ($scope.have_sub_skill) {
                        if(templateCard.skill_only){
                            $scope.skill_only = true
                        }
                        _.each($scope.selectedactivities, function(curData, key) {
                            if(curData.sub_skills){
                                _.each(curData.sub_skills, function(data, key) {
                                    data.selection = "best";
                                    data.list = []
                                })
                            }else{
                                if(templateCard.skill_only){
                                    curData.list = []
                                    curData.selection = "best";
                                }
                            }
                        })
                    } else {
                        _.each($scope.selectedactivities, function(curData, key) {
                            curData.selection = "best";
                        })
                    }

                }

                _.defer(function() { $scope.$apply(); });;
            })
        }
        self.showItem = function(data) {

            _.each($scope.activities, function(curData, key) {
                if (curData != data) {
                    curData.showItem = false;
                }
            })
            data.showItem = true
        }

        self.showSelectedItem = function(data) {

            _.each($scope.selectedactivities, function(curData, key) {

                curData.showItem = false;
                _.each(curData.sub_skills, function(data, key) {
                    data.isdisplay = false;
                })

            })
            data.showItem = true
        }
        self.flagdata = function(data) {
            _.each($scope.selectedactivities, function(curData, key) {

                curData.showItem = true;
                _.each(curData.sub_skills, function(data, key) {
                    data.isdisplay = false;

                })


            })
        }

        self.flagNoSkill = function() {
            $scope.showItem = true;
        }
        self.showMore = function(activity, item) {
            /* $scope.selectedactivities.*/

            _.find($scope.selectedactivities, function(data) {
                if (activity == data) {
                    activity.showItem = false;
                    _.find(activity.sub_skills, function(data1) {
                        /*if (data1.list.length > 1) {
                          data1.selection = "best";

                        }*/
                        if (data1 == item) {
                            data1.isdisplay = true;
                        }
                    })


                }



            })

        }

        self.showNoSkill = function(activity) {
            /* $scope.selectedactivities.*/
            $scope.showItem = false;
            _.find($scope.selectedactivities, function(data) {
                if (activity == data) {
                    activity.showItem = true;
                    /*if (data.list.length > 1)
                    {
                        data.selection = "best";

                     } */
                }
            })
        }


        self.closed = function(activity) {
            activity.showItem = false;
            $scope.showItem = true;
        }
        self.close = function(activity, item) {
            activity.showItem = true;
            item.isdisplay = false;
        }

        self.openMenu = function($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
        };
        self.deleteSession = function(item, data) {
            _.each($scope.activities, function(curData, key) {
                if (curData.type == data.type) {
                    curData.list.push(data)
                }
            })
            item.list = _.without(item.list, data)

            if (item.list.length < 1) {
                data.selection = undefined;
            }
        }
        self.deleteSessions = function(item, data) {

            _.each($scope.activities, function(curData, key) {

                if (curData.type == data.type) {
                    curData.list.push(data)
                }
            })
            item.list = _.without(item.list, data)

            if (item.list.length < 1) {
                data.selection = undefined;
            }
        }
        self.dragControlListeners = {
            //optional param
            containment: '#sortable-container'
        };
        function showErrorOnDrag(){
            if($scope.templateCard && $scope.templateCard.no_conversion){
                return true
            }
            return false
        }
        self.sortableCloneOptions1 = {
            containment: '#sortable-container',
            allowDuplicates: true,
            ctrlClone: true,
            dragEnd: function(event) {
            },
            accept: function(sourceItemHandleScope, destSortableScope) {
                let allow = true
                let noMoreActivities = showErrorOnDrag()
                if(destSortableScope.$parent && destSortableScope.$parent.activity &&
                destSortableScope.$parent.activity.list && destSortableScope.$parent.activity.list.length){
                    if(noMoreActivities){
                        allow = false
                        toastr.error("Sorry, Only one entry is possible to add")
                    }
                }
                return allow;
            },

        };
        self.makeReportCard = (ev) => {
            $scope.errorarray = [];
            $scope.validationArray = []
            if ($scope.have_sub_skill) {
              _.each($scope.selectedactivities, function(curData, key) {
                if(curData.sub_skills){
                  _.each(curData.sub_skills, function(data, key) {
                    if (data.list.length <= 0) {
                      let obj = {
                        skill_name : curData.name,
                        sub_skill : data.name
                      }
                      $scope.validationArray.push(obj)
                      $scope.errorarray.push(data.name + " under " + curData.name + " contains no elements")
                    }
                  })
                }else{
                    _.each($scope.selectedactivities, function(curData, key) {
                        if (curData.list.length <= 0) {
                          let obj = {
                                skill_name : curData.name
                              }
                          $scope.validationArray.push(obj)
                          $scope.errorarray.push(curData.name + " contains no elements")
                        }
                      })
                }
              })
            } else {
              _.each($scope.selectedactivities, function(curData, key) {
                if (curData.list.length <= 0) {
                  let obj = {
                        skill_name : curData.name
                      }
                  $scope.validationArray.push(obj)
                  $scope.errorarray.push(curData.name + " contains no elements")
                }
              })
            }
            var errorString = $scope.errorarray.join()
        errorString = errorString.replace(/,/gi, "\n").replace(/^,/, "");
        /*alert(errorString)*/
        if ($scope.errorarray.length > 0) {
            // var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'validationData', validationCtrl],
                locals: {
                    "validationData": $scope.validationArray,

                },
                template: reportCardValidationPopup,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                // fullscreen: useFullScreen
            })
            return false
        }
        // if ($scope.errorarray.length === 0) {
          if (activityCondition) {
            activityCondition['batch_id'] = batchId
            if(fromCt == "true"){
                let cTData = localStorageService.get('cTregen')
                activityCondition = {
                    "subject_id": cTData.subject_id,
                    "session_id": cTData.session_id,
                    "curriculum_id": cTData.curriculum_id,
                    "class_id": cTData.class_id,
                    "batch_id": cTData.batch_id,
                    "school_id": cTData.school_id,
                    academic_year : activeAcd
                }
            }
            // console.log(activityCondition)
            let select_regen = false
            if(re_generate && fromCt && $scope.get_students_selected && $scope.get_students_selected.length){
                select_regen = true
            }
            let passObj = {
                cardId : templateCardId,
                valuesUnderSkills : $scope.selectedactivities,
                activityCondition : activityCondition,
                dataId : dataId,
                re_generateFlag : re_generate,
                fromCt : fromCt,
                select_regen : select_regen,
                get_students_selected : $scope.get_students_selected ? $scope.get_students_selected : [],
                myUserId : localStorageService.get('user_id')
            }
            console.log(passObj)
            // return false
            $scope.loading = true
            authService.callAPI("/v0/reportcards/teacher/start", "POST",
                {args : passObj}, function (response) {
                    $scope.loading = false
                    try{
                        if(response.error && response.error.error == "Already generated the report!"){
                            toastr.error(response.error.error)
                            $state.go('reportCardListing')
                        }else{

                            let result = response.result.data.details.response
							console.log(result,"ersuluuuuuuuuuuuuuuuuuuuuu")

                            if (result) {
                                toastr.success("Generated the report")
                                if(re_generate == 'true'){
                                    $state.go('viewGeneratedReportData', {
                                        "dataId": result._id,
                                        "selected_year" : activeAcd,
                                        is_edit : false
                                        })
                                }else{
                                    if(result._id._id){
                                        $state.go('viewGeneratedReportData', {
                                            "dataId": result._id._id,
                                            "selected_year" : activeAcd,
                                            is_edit : false
                                            })
                                    }else{
                                        $state.go('viewGeneratedReportData', {
                                            "dataId": result._id,
                                            "selected_year" : activeAcd,
                                            is_edit : false
                                            })
                                    }

                                }


                            }
                        }
                    }catch(e){
                        console.log(e)
                        $scope.loading = false
                    }
                })
          }
        }
		function pushLog(){
            let userId = localStorageService.get('user_id');
            let schoolId = localStorageService.get('school_id');
            authService.callRabbitMQAPI("/v0/rabbitmqpush/"+userId+"/"+schoolId+"/reportCardGenerationView", "GET", {},function (response) {
            // console.log(response)
			});
		}
    }
}
class validationCtrl {
    constructor($scope, $mdDialog, validationData) {
         let skillsArray = _.pluck(validationData,"skill_name")
        skillsArray = _.compact(skillsArray)
        let noValidArray = []
        _.each(skillsArray, function(doc){
            let filterSkill = _.filter(validationData, function(each){
              return each.skill_name == doc
            })
            let pluckSubSkills = _.pluck(filterSkill, "sub_skill")
            pluckSubSkills = _.compact(pluckSubSkills)
            if(filterSkill.length){
               let obj = {
                skill_name : doc,
                sub_skill : pluckSubSkills
              }
              noValidArray.push(obj)
            }
        })

        noValidArray = _.uniq(noValidArray, false, function(p){ return p.skill_name; });
        $scope.validationArray = noValidArray

        $scope.hide = function() {
          $mdDialog.hide();
        };

        $scope.cancel = function() {
          $mdDialog.cancel();
        };

        $scope.answer = function(answer) {
          $mdDialog.hide(answer);
        };
    }
}
export default ReportCardGenConsoleCtrl;



// WEBPACK FOOTER //
// ./src/app/report_cards/teacher/generation/controllers/reportcardController.js